import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Button,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import commonComponents from "../../../../components/common";

import authServices from "../../../../services/auth";
import global from "../../../../config/global";

const PersonalInfo = () => {
  const { UserAvatar } = commonComponents;
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.auth.userInfo);

  const [fingerprint, setFingerprint] = useState(null);

  useEffect(() => {
    getFingerprint();
  }, [])

  const getFingerprint = async () => {
    const fingerprintData = await global.jsCore.cryptoService.getFingerprint(await global.jsCore.userService.getUserId())
    if (fingerprintData != null) {
      setFingerprint(fingerprintData.join('-'))
    } else {
      setFingerprint('')
    }
  }

  return (
    <div>
      <Card bodyStyle={{ padding: 16 }} className="mb-4">
        <div className="flex justify-between">
          <UserAvatar size={48}/>
          <Button
            danger
            onClick={() => authServices.logout()}
          >
            {t('button.logout')}
          </Button>
        </div>
      </Card>
      <Card bodyStyle={{ padding: 16 }} className="mb-4">
        <div className="flex justify-between">
          <div>
            <p>{t('common.email_addresses')}</p>
            <p className="font-semibold">{userInfo?.email}</p>
          </div>
          <div>
            <p>{t('common.country')}</p>
            <p className="font-semibold">{userInfo?.country}</p>
          </div>
          <Button
            type="primary"
            ghost
            onClick={() => window.open(`${global.urls.LOCKER_ID_URL}`, '_blank')}
          >
            {t('button.edit_profile')}
          </Button>
        </div>
      </Card>
      <Card bodyStyle={{ padding: 16 }}>
        <div className="flex justify-between">
          <div>
            <p>{t('common.fingerprint')}</p>
            <p className="text-danger">{fingerprint}</p>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default PersonalInfo;